import { render, staticRenderFns } from "./TransferredTable.vue?vue&type=template&id=3d40e41a"
import script from "./TransferredTable.vue?vue&type=script&lang=js"
export * from "./TransferredTable.vue?vue&type=script&lang=js"
import style0 from "./TransferredTable.vue?vue&type=style&index=0&id=3d40e41a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports